export const enums = {
  common: {
    aspect: ["N", "NE", "E", "SE", "S", "SW", "W", "NW"],
    flag: [true, false],
  },
  // --------------------------------------------------------------------
  dangerSign: {
    frequency: ["NONE", "RARELY", "OFTEN"],
    snowdriftSize: ["NONE", "SMALL", "MEDIUM", "LARGE"],
    dangerOf: ["DRY", "WET", "FULL_DEPTH"],
    altitudeAbove: [true, false],
    level: ["1", "2", "3", "4", "5"],
  },
  // --------------------------------------------------------------------
  avalanche: {
    avalancheSize: ["ONE", "TWO", "THREE", "FOUR", "FIVE", "UNKNOWN"],
    avalancheType: ["SLAB", "LOOSE_SNOW", "FULL_DEPTH", "UNKNOWN"],
    avalancheMoisture: ["DRY", "WET", "UNKNOWN"],
    triggerType: [
      "NATURAL",
      "PERSON",
      "EXPLOSIVE",
      "SNOW_GROOMER",
      "OTHER",
      "UNKNOWN",
    ],
    burialType: ["NOT", "PARTIAL", "COMPLETE"],
    personDamageType: ["UNINJURED", "INJURED", "DEAD"],
  },
  // --------------------------------------------------------------------
  personalData: {
    education: [
      "TOURING_SKIER",
      "TOURING_GUIDE",
      "SKIING_INSTRUCTOR",
      "MOUNTAIN_GUIDE",
      "RESCUE_SERVICE",
      "AVALANCHE_SERVICE",
      "OTHER",
    ],
  },
};

export const i18nMixin = {
  methods: {
    i18n(e, v) {
      return v ? this.$i18n.t(e + "." + v) : "";
    },
    enums(e) {
      return enums[e];
    },
    options(g, e, notnull) {
      const options = enums[g][e].map((x) => {
        return {
          value: x,
          text: this.$i18n.t([g, e, x].join(".")),
        };
      });
      if (!notnull) {
        options.unshift({ value: null, text: this.$i18n.t("ui.select") });
      }
      return options;
    },
  },
};
